import React, {useEffect, useMemo} from 'react';
import {Link} from '~/components/Link';

import _ from 'lodash';
import {Form, useMatches} from '@remix-run/react';
import {IRoute} from '~/types';
import {HEADER_STYLE, get, logger} from '~/utils';
import {usePrefixPathWithLocale} from '~/lib/utils';

const DEFAULT_LOGO =
  'https://res.cloudinary.com/oves/image/upload/v1657359850/logos/oves_logo_words_h50_w3axpd.png';

const NavbarSection = ({
  logo = DEFAULT_LOGO,
  menuItems: _menuItems,
  headerStyle,
  isAuthenticated,
  menu: _menu,
}: {
  title: string;
  logo: string;
  isAuthenticated: boolean;
  menuItems?: IRoute[];
  headerStyle?: string;
  menu?: any;
}) => {
  // Add active class
  const menuItems = useMemo(
    () =>
      _.map(get(_menu, 'menuItems'), (it) => {
        return {
          name: get(it, 'name'),
          route: `/${get(it, 'page.handle')}`,
          id: get(it, 'id'),
          handle: `/pages/${get(it, 'page.handle')}`,
          slug: `/${get(it, 'page.handle')}`,
        };
      }),
    [_menu],
  );
  const router = {};
  useEffect(() => {}, [router]);

  const [root] = useMatches();
  const [menu, setMenu] = React.useState(true);

  const toggleNavbar = () => {
    setMenu(!menu);
  };

  React.useEffect(() => {
    const elementId = document.getElementById('header');
    document.addEventListener('scroll', () => {
      if (window.scrollY > 170) {
        elementId?.classList.add('is-sticky');
      } else {
        elementId?.classList.remove('is-sticky');
      }
    });
  });

  const classOne = menu
    ? 'collapse navbar-collapse'
    : 'collapse navbar-collapse show';
  const classTwo = menu
    ? 'navbar-toggler navbar-toggler-right collapsed'
    : 'navbar-toggler navbar-toggler-right';

  return (
    <>
      <header
        id="header"
        className={`headroom ${
          headerStyle == HEADER_STYLE.DARK_HEADER
            ? 'navbar-color-white navbar-style-four'
            : 'navbar-style-three'
        }`}
      >
        <div className="startp-nav">
          <div className="container">
            <nav className={`navbar navbar-expand-md navbar-light`}>
              <Link to="/" className="navbar-brand">
                <img src={logo} alt="logo" />
              </Link>

              <button
                onClick={toggleNavbar}
                className={classTwo}
                type="button"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="icon-bar top-bar"></span>
                <span className="icon-bar middle-bar"></span>
                <span className="icon-bar bottom-bar"></span>
              </button>

              <div className={classOne} id="navbarSupportedContent">
                <ul className="navbar-nav ms-auto">
                  {menuItems?.map((item) => (
                    <li className="nav-item" key={item.route}>
                      <Link
                        key={item.route}
                        to={`${item.handle}`}
                        prefetch="intent"
                        className={({isActive}) =>
                          isActive ? 'active' : 'pb-1'
                        }
                      >
                        {item.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>

              

              {/* Others option */}
              <div className="others-option">
                {/* <Link to="/cart/" className="cart-wrapper-btn">
                  <Suspense fallback={<Icon.ShoppingCart />}>
                    <Await resolve={root.data?.cart}>
                      {(cart) => (
                        <>
                          <Icon.ShoppingCart />
                          {cart?.totalQuantity ? (
                            <span>{cart?.totalQuantity || 0}</span>
                          ) : null}
                        </>
                      )}
                    </Await>
                  </Suspense>
                </Link> */}
                {/* {!isAuthenticated ? (
                  <Link to="/account/login/" className="btn btn-primary">
                    Sign in
                  </Link>
                ) : null} */}
                {isAuthenticated ? (
                  <Form
                    method="post"
                    action={usePrefixPathWithLocale('/account/logout')}
                  >
                    <button type="submit" className="btn btn-primary">
                      Sign out
                    </button>
                  </Form>
                ) : null}
              </div>
            </nav>
          </div>
        </div>
      </header>
    </>
  );
};

export default NavbarSection;
